{
  "tabs": {
    "chat": "Συνομιλία",
    "reminders": "Υπενθυμίσεις",
    "calendar": "Ημερολόγιο",
    "settings": "Ρυθμίσεις"
  },
  "common": {
    "cancel": "Άκυρο",
    "save": "Αποθήκευση",
    "confirm": "Επιβεβαίωση",
    "delete": "Διαγραφή",
    "back": "Πίσω",
    "close": "Κλείσιμο",
    "edit": "Επεξεργασία",
    "search": "Αναζήτηση",
    "all": "Όλα",
    "loading": "Φόρτωση...",
    "error": "Κάτι πήγε στραβά",
    "notFound": "Δεν βρέθηκε",
    "tryAgain": "Παρακαλώ δοκιμάστε ξανά",
    "retry": "Επανάληψη",
    "undo": "Αναίρεση",
    "pullToRefresh": "Τραβήξτε για ανανέωση",
    "justNow": "μόλις τώρα"
  },
  "auth": {
    "welcome": "Καλώς ήρθατε στο FishMemory",
    "tagline": "Ο βοηθός υπενθυμίσεων WhatsApp, τώρα στην τσέπη σας.",
    "subtitle": "Ο βοηθός υπενθυμίσεων WhatsApp, τώρα στην τσέπη σας.",
    "phoneLabel": "Ο αριθμός WhatsApp σας",
    "phoneHint": "Θα στείλουμε κωδικό επαλήθευσης μέσω WhatsApp",
    "invalidPhone": "Παρακαλώ εισάγετε έγκυρο αριθμό τηλεφώνου",
    "continue": "Συνέχεια",
    "enterPhone": "Εισάγετε τον αριθμό WhatsApp σας",
    "phonePlaceholder": "Αριθμός τηλεφώνου",
    "sendCode": "Αποστολή κωδικού",
    "verifyTitle": "Επαληθεύστε τον αριθμό σας",
    "otpSentTo": "Ένας 6ψήφιος κωδικός στάλθηκε στο {{phone}} μέσω WhatsApp",
    "enterFullCode": "Παρακαλώ εισάγετε και τα 6 ψηφία",
    "invalidOtp": "Μη έγκυρος κωδικός. Δοκιμάστε ξανά.",
    "otpFailed": "Αποτυχία αποστολής κωδικού. Δοκιμάστε ξανά.",
    "otpResent": "Κωδικός ξαναστάλθηκε",
    "resendIn": "Ξαναστείλετε σε {{seconds}}δ",
    "resendCode": "Ξαναστείλετε κωδικό",
    "enterOtp": "Εισάγετε τον κωδικό που στάλθηκε στο WhatsApp σας",
    "verify": "Επαλήθευση",
    "resend": "Ξαναστείλετε κωδικό",
    "wrongNumber": "Λάθος αριθμός;",
    "backToPhone": "Πίσω στον αριθμό",
    "editPhone": "Επεξεργασία αριθμού",
    "error": "Σφάλμα",
    "setupTitle": "Ας ρυθμίσουμε τα πράγματα",
    "setupSubtitle": "Μπορείτε πάντα να αλλάξετε αυτά αργότερα στις Ρυθμίσεις",
    "namePlaceholder": "Το όνομά σας",
    "letsGo": "Ολοκλήρωση ρύθμισης",
    "skipForNow": "Παράλειψη προς το παρόν"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Πληκτρολογήστε μήνυμα...",
    "inputPlaceholder": "Πληκτρολογήστε μήνυμα...",
    "typing": "Το FishMemory πληκτρολογεί...",
    "online": "Σε σύνδεση",
    "connecting": "Σύνδεση...",
    "reconnecting": "Επανασύνδεση...",
    "offline": "Αποσυνδεδεμένο",
    "empty": "Ξεκινήστε μια συνομιλία",
    "emptyHint": "Δημιουργήστε υπενθυμίσεις, δείτε το πρόγραμμα ή ζητήστε βοήθεια.",
    "emptyAction": "Στείλτε μια δοκιμαστική υπενθύμιση",
    "actions": "Ενέργειες συνομιλίας",
    "keep": "Διατήρηση μηνυμάτων",
    "clearTitle": "Καθαρισμός συνομιλίας",
    "clearConfirm": "Διαγράψτε όλα τα μηνύματα από αυτή τη συσκευή; Δεν μπορεί να αναιρεθεί.",
    "clear": "Καθαρισμός συνομιλίας",
    "optionSelected": "Επιλέχθηκε: {{label}}",
    "sendingSelection": "Αποστολή...",
    "connectionLost": "Επανασύνδεση..."
  },
  "reminders": {
    "title": "Οι Υπενθυμίσεις μου",
    "active": "Ενεργές",
    "today": "Σήμερα",
    "thisWeek": "Αυτή την Εβδομάδα",
    "history": "Ιστορικό",
    "items": "αντικείμενα",
    "emptyTitle": "Δεν υπάρχουν υπενθυμίσεις",
    "emptySubtitle": "Δημιουργήστε μία από τη συνομιλία και θα εμφανιστεί εδώ.",
    "emptyAction": "Άνοιγμα συνομιλίας",
    "filterActive": "Ενεργές",
    "filterToday": "Σήμερα",
    "filterWeek": "Αυτή την Εβδομάδα",
    "filterHistory": "Ιστορικό",
    "emptyState": "Δεν υπάρχουν υπενθυμίσεις. Ξεκινήστε να συνομιλείτε!",
    "swipeDone": "Ολοκληρώθηκε",
    "swipeSnooze": "Αναβολή",
    "swipeDelete": "Διαγραφή",
    "search": "Αναζήτηση υπενθυμίσεων...",
    "upcoming": "Επερχόμενες",
    "completed": "Ολοκληρωμένες",
    "overdue": "Καθυστερημένες",
    "tomorrow": "Αύριο",
    "synced": "Συγχρονίστηκαν {{value}}",
    "swipeHint": "Σύρετε μια υπενθύμιση για περισσότερες ενέργειες",
    "noResults": "Καμία υπενθύμιση δεν ταιριάζει με την αναζήτησή σας",
    "noResultsHint": "Δοκιμάστε διαφορετική λέξη ή καθαρίστε την αναζήτηση",
    "deleteAllFailed": "Αποτυχία διαγραφής όλων των υπενθυμίσεων"
  },
  "calendar": {
    "title": "Ημερολόγιο",
    "today": "Σήμερα",
    "tomorrow": "Αύριο",
    "completed": "ολοκληρώθηκε",
    "noEvents": "Καμία προγραμματισμένη εκδήλωση",
    "noEventsSubtitle": "Επιλέξτε ημερομηνία για να δείτε υπενθυμίσεις και εκδηλώσεις ημερολογίου.",
    "googleEvent": "Google Calendar",
    "legendActive": "Ενεργό",
    "legendRecurring": "Επαναλαμβανόμενο",
    "legendDone": "Ολοκληρωμένο",
    "legendGoogle": "Google",
    "previousMonth": "Προηγούμενος μήνας",
    "nextMonth": "Επόμενος μήνας",
    "previousYear": "Προηγούμενο έτος",
    "nextYear": "Επόμενο έτος",
    "goToToday": "Πήγαινε στο σήμερα",
    "all": "Όλα",
    "active": "Ενεργό",
    "done": "Ολοκληρωμένο",
    "paused": "Παύση"
  },
  "settings": {
    "title": "Ρυθμίσεις",
    "profile": "Προφίλ",
    "name": "Όνομα εμφάνισης",
    "enterName": "Εισάγετε το όνομά σας",
    "language": "Γλώσσα",
    "uiLanguage": "Γλώσσα εφαρμογής",
    "uiLanguageHelp": "Αλλάζει τη γλώσσα διεπαφής, τις ετικέτες ημερολογίου και την κατεύθυνση διάταξης μόνο σε αυτή τη συσκευή.",
    "serverLanguage": "Γλώσσα συνομιλίας",
    "serverLanguageHelp": "Αλλάζει τη γλώσσα απαντήσεων διακομιστή και μηνυμάτων υπενθύμισης για τον λογαριασμό σας.",
    "timezone": "Ζώνη ώρας",
    "currentTimezone": "Τρέχουσα ζώνη ώρας",
    "timezoneHelp": "Όλες οι ώρες υπενθυμίσεων εμφανίζονται με αυτή τη ζώνη ώρας.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Αποθήκευση ζώνης ώρας",
    "timezoneSaved": "Η ζώνη ώρας ενημερώθηκε",
    "detect": "Ανίχνευση",
    "detectFailed": "Αδυναμία ανίχνευσης ζώνης ώρας",
    "autoDetect": "Αυτόματη ανίχνευση από GPS",
    "notifications": "Ειδοποιήσεις",
    "notificationsHelp": "Οι υπενθυμίσεις επανειδοποίησης ελέγχουν τις επαναλαμβανόμενες ειδοποιήσεις μετά την παράδοση μιας υπενθύμισης. Τα δικαιώματα ειδοποιήσεων σε επίπεδο συσκευής διαχειρίζονται στις ρυθμίσεις του τηλεφώνου σας.",
    "pushEnabled": "Ειδοποιήσεις Push",
    "autoDoneOnFire": "Αυτόματη σήμανση ως ολοκληρωμένη όταν ενεργοποιείται",
    "autoDoneOnFireDesc": "Όταν είναι απενεργοποιημένο, οι υπενθυμίσεις παραμένουν ενεργές μέχρι να τις σημειώσετε ως ολοκληρωμένες.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Συνδεδεμένο",
    "googleDisconnected": "Μη συνδεδεμένο",
    "googleConnectedHelp": "Νέες υπενθυμίσεις μπορούν να συγχρονιστούν αυτόματα με το ημερολόγιό σας.",
    "googleDisconnectedHelp": "Συνδέστε το Google Calendar για να κρατάτε υπενθυμίσεις και εκδηλώσεις συγχρονισμένες.",
    "googleConnectFailed": "Αποτυχία σύνδεσης με Google Calendar",
    "connected": "Συνδεδεμένο",
    "disconnected": "Μη συνδεδεμένο",
    "connect": "Σύνδεση",
    "disconnect": "Αποσύνδεση",
    "autoSync": "Αυτόματος συγχρονισμός νέων υπενθυμίσεων",
    "autosync": "Αυτόματος συγχρονισμός νέων υπενθυμίσεων",
    "subscription": "Συνδρομή",
    "trialUsed": "Δοκιμή: {{used}}/{{total}} χρησιμοποιημένα",
    "trialStatus": "Διαθέσιμη δοκιμή",
    "activeStatus": "Ενεργή συνδρομή",
    "expiredStatus": "Η συνδρομή έληξε",
    "unsubscribedStatus": "Μη εγγεγραμμένος",
    "about": "Πληροφορίες",
    "version": "Έκδοση",
    "logout": "Αποσύνδεση",
    "logoutTitle": "Αποσύνδεση",
    "logoutConfirm": "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;",
    "noName": "Δεν έχει οριστεί όνομα",
    "serverConnection": "Σύνδεση διακομιστή",
    "serverUrl": "Διεύθυνση URL διακομιστή",
    "serverEdit": "Επεξεργασία",
    "saveReconnect": "Αποθήκευση και επανασύνδεση",
    "resetDefault": "Επαναφορά προεπιλογής",
    "invalidServerUrlTitle": "Μη έγκυρη διεύθυνση URL διακομιστή",
    "invalidServerUrlMessage": "Εισάγετε έγκυρη διεύθυνση http ή https, π.χ. https://example.com",
    "uiLanguageChangeFailed": "Αποτυχία αλλαγής γλώσσας εφαρμογής. Παρακαλώ δοκιμάστε ξανά.",
    "serverLanguageChangeFailed": "Αποτυχία αλλαγής γλώσσας συνομιλίας. Παρακαλώ δοκιμάστε ξανά.",
    "timezoneChangeFailed": "Αποτυχία αλλαγής ζώνης ώρας. Παρακαλώ δοκιμάστε ξανά.",
    "autoSyncChangeFailed": "Αποτυχία ενημέρωσης αυτόματου συγχρονισμού. Παρακαλώ δοκιμάστε ξανά.",
    "nameChangeFailed": "Αποτυχία ενημέρωσης ονόματος εμφάνισης. Παρακαλώ δοκιμάστε ξανά.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Λεπτομέρειες υπενθύμισης",
    "editTime": "Επεξεργασία ώρας",
    "rename": "Μετονομασία",
    "snooze": "Αναβολή",
    "snooze15": "Αναβολή 15 λεπτά",
    "pause": "Παύση",
    "pauseReminder": "Παύση υπενθύμισης",
    "resume": "Συνέχεια",
    "resumeReminder": "Συνέχεια υπενθύμισης",
    "skip": "Παράλειψη επόμενου",
    "skipOccurrence": "Παράλειψη αυτής της εμφάνισης",
    "syncGoogle": "Συγχρονισμός με Google",
    "delete": "Διαγραφή",
    "deleteTitle": "Διαγραφή υπενθύμισης",
    "deleteConfirm": "Αυτή η υπενθύμιση θα διαγραφεί οριστικά.",
    "deleteRecurringTitle": "Διαγραφή επαναλαμβανόμενης υπενθύμισης",
    "deleteRecurringMessage": "Θέλετε να παραλείψετε αυτή την εμφάνιση ή να διαγράψετε ολόκληρη τη σειρά;",
    "deleteThisOccurrence": "Παράλειψη αυτής της εμφάνισης",
    "deleteEntireSeries": "Διαγραφή ολόκληρης της σειράς",
    "done": "Ολοκληρώθηκε",
    "markDone": "Σήμανση ως ολοκληρωμένη",
    "undo": "Επαναφορά",
    "undoPrompt": "Χρειάζεται ξανά ενεργή; Επαναφέρετε τώρα.",
    "recurring": "Επαναλαμβανόμενη",
    "nextRun": "Επόμενη εκτέλεση",
    "oneTime": "Μίας φοράς",
    "pending": "Εκκρεμεί",
    "sent": "Απεστάλη",
    "paused": "Σε παύση",
    "active": "Ενεργή",
    "snoozed": "Αναβλήθηκε",
    "localTime": "Εμφανίζεται στην τοπική σας ώρα",
    "recurrence": "Επανάληψη",
    "created": "Δημιουργήθηκε",
    "tags": "Ετικέτες",
    "fireCount": "Φορές ενεργοποίησης",
    "actions": "Ενέργειες",
    "none": "Καμία",
    "snoozeFailed": "Αποτυχία αναβολής υπενθύμισης",
    "pauseFailed": "Αποτυχία παύσης υπενθύμισης",
    "resumeFailed": "Αποτυχία συνέχισης υπενθύμισης",
    "skipFailed": "Αποτυχία παράλειψης υπενθύμισης",
    "doneFailed": "Αποτυχία σήμανσης υπενθύμισης ως ολοκληρωμένης",
    "undoFailed": "Αποτυχία επαναφοράς κατάστασης υπενθύμισης",
    "deleteFailed": "Αποτυχία διαγραφής υπενθύμισης",
    "rescheduleTitle": "Να προγραμματιστεί ξανά;",
    "rescheduleMsg": "Αυτή η υπενθύμιση είναι καθυστερημένη. Θέλετε να την προγραμματίσετε ξανά;",
    "reschedule15": "Σε 15 λεπτά",
    "reschedule60": "Σε 1 ώρα",
    "keepOverdue": "Διατήρηση ως έχει"
  },
  "onboarding": {
    "slide1Title": "Καλώς ήρθατε στο FishMemory",
    "slide1Sub": "Ο προσωπικός σας βοηθός υπενθυμίσεων — με τη δύναμη του WhatsApp και σχεδιασμένος για την τσέπη σας.",
    "slide2Title": "Απλά συνομιλήστε φυσικά",
    "slide2Sub": "Πληκτρολογήστε υπενθυμίσεις όπως τις σκέφτεστε: «Υπενθύμισέ μου να καλέσω τη μαμά αύριο στις 3μμ» — εμείς αναλαμβάνουμε τα υπόλοιπα.",
    "slide3Title": "Μην χάνετε ποτέ τίποτα",
    "slide3Sub": "Λάβετε έγκαιρες ειδοποιήσεις, οργανώστε με ετικέτες και μείνετε ενημερωμένοι για όλα τα σημαντικά.",
    "getStarted": "Ξεκινήστε",
    "next": "Επόμενο",
    "firstReminderTitle": "Δημιουργήστε την πρώτη σας υπενθύμιση!",
    "firstReminderHint": "Δοκιμάστε να πληκτρολογήσετε κάτι όπως:",
    "firstReminderExample": "Υπενθύμισέ μου να πιω νερό αύριο στις 9 πμ",
    "gotIt": "Εντάξει!",
    "notifRationaleTitle": "Μείνετε στην ώρα σας",
    "notifRationaleBody": "Το FishMemory χρειάζεται ειδοποιήσεις για να σας υπενθυμίζει στην ώρα του. Θα λαμβάνετε ειδοποιήσεις μόνο για τις υπενθυμίσεις που δημιουργείτε.",
    "notifRationaleAllow": "Ενεργοποίηση ειδοποιήσεων",
    "notifRationaleLater": "Ίσως αργότερα",
    "swipeHint": "Σύρετε δεξιά για γρήγορες ενέργειες →",
    "calendarDragHint": "Σύρετε για μεγέθυνση ↕"
  }
}
